document.addEventListener("DOMContentLoaded", function () {
    const modal = document.querySelector(".schedule_delivery_modal");
    const scheduleDeliveryContainer = document.querySelector(".schedule_delivery__container");
    const scheduleDeliveryTrigger = document.querySelectorAll(".schedule_delivery__trigger-element");
    const scheduleDeliveryButton = document.querySelector(".schedule_delivery__element");
    const deliveryDateInput = document.querySelector("#delivery-date");
    const scheduleDeliveryModalAdd = document.querySelector(".schedule_delivery_modal_add");
    const addToCartButton = document.querySelector(".product-form__submit");
    const calendar = document.getElementById("calendar");
    const selectedDateText = document.getElementById("selectedDateText");
    const clearButton = document.getElementById("clearButton");
    const cancelButton = document.getElementById("cancelButton");
    const closeButton = document.querySelector(".close-button");
    const prevMonthButton = document.getElementById("prevMonth");
    const nextMonthButton = document.getElementById("nextMonth");
    const monthDropdown = document.getElementById("monthDropdown");

    let selectedDate = null;
    let selectedDateString = "";
    const today = new Date(); // Today's date
    let currentYear = today.getFullYear();
    let currentMonth = today.getMonth();

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    // Open modal when "Schedule Delivery" button is clicked
    document.body.addEventListener("click", function(e) {

        if (e.target.closest(".schedule_delivery__trigger-element")) {
            e.preventDefault();
            modal.setAttribute("active", true);
            populateMonthDropdown();
            generateCalendar(currentYear, currentMonth);
        }
    })
    // scheduleDeliveryTrigger.forEach(trg => {
    //     trg.addEventListener("click", function (e) {
    //         e.preventDefault();
    //         modal.setAttribute("active", true);
    //         populateMonthDropdown();
    //         generateCalendar(currentYear, currentMonth);
    //     });
    // })

    // Populate the month dropdown with valid months (next 12 months)
    function populateMonthDropdown() {
        monthDropdown.innerHTML = "";
        const endDate = new Date(today.getFullYear(), today.getMonth() + 12, 0);

        for (
            let date = new Date(today);
            date <= endDate;
            date.setMonth(date.getMonth() + 1)
        ) {
            const option = document.createElement("option");
            const month = date.getMonth();
            const year = date.getFullYear();
            option.value = `${year}-${month}`;
            option.textContent = `${months[month]} ${year}`;

            if (month === currentMonth && year === currentYear) {
                option.selected = true;
            }

            monthDropdown.appendChild(option);
        }
    }

    // Generate the calendar for the selected year and month
    function generateCalendar(year, month) {
        const firstDayOfMonth = new Date(year, month, 1).getDay(); // Day of the week (0 = Sunday, 1 = Monday, etc.)
        const daysInMonth = new Date(year, month, 0).getDate(); // Total days in the month

        calendar.innerHTML = "";

        // Add weekday header
        const weekdays = ["M", "T", "W", "T", "F", "S", "S"];
        weekdays.forEach((weekday) => {
            const weekdayCell = document.createElement("div");
            weekdayCell.textContent = weekday;
            calendar.appendChild(weekdayCell);
        });

        // Adjust the starting day for a Monday-start week
        const adjustedFirstDay = (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1);

        // Add empty cells for days before the first day of the month
        for (let i = 0; i < adjustedFirstDay; i++) {
            const emptyCell = document.createElement("div");
            emptyCell.style.visibility = "hidden"; // Hide empty cells for better visual alignment
            calendar.appendChild(emptyCell);
        }

        // Add buttons for each day in the month
        for (let day = 1; day <= daysInMonth; day++) {
            const dateButton = document.createElement("button");
            const currentDate = new Date(year, month, day);

            dateButton.textContent = day;

            // Disable past dates
            if (currentDate < today) {
                dateButton.disabled = true;
                dateButton.style.color = "#ccc"; // Make past dates visually distinct
            } else {
                dateButton.addEventListener("click", function (e) {
                    selectDate(e, year, month, day);
                });
            }

            calendar.appendChild(dateButton);
        }
    }

    // Update the month dropdown to match the selected year and month
    function updateMonthDropdown(year, month) {
        const options = Array.from(monthDropdown.options);
        options.forEach((option) => {
            const [optionYear, optionMonth] = option.value.split("-").map(Number);
            if (optionYear === year && optionMonth === month) {
                option.selected = true;
            }
        });
    }

    // Handle selecting a date
    function selectDate(event, year, month, day) {
        document.querySelectorAll("#calendar button").forEach((btn) =>
            btn.classList.remove("selected")
        );
        event.target.classList.add("selected");

        selectedDate = `${year}-${month}-${day}`;
        let date = new Date(year, month, day);
        selectedDateString = date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        selectedDateText.textContent = `Selected Date: ${selectedDateString}`;
        // deliveryDateInput.setAttribute("value", selectedDate);

        // Enable "Schedule Order" button
        scheduleDeliveryModalAdd.removeAttribute("disabled");
    }

    // Clear the selected date but do not close the modal
    function clearSelection() {
        selectedDate = null;
        selectedDateText.textContent = "";
        // deliveryDateInput.setAttribute("value", "");
        scheduleDeliveryModalAdd.setAttribute("disabled", true);
        document.querySelectorAll("#calendar button").forEach((btn) =>
            btn.classList.remove("selected")
        );
        cartAttributes["Delivery Date"] = "";


        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: cartAttributes
            })
        })
            .then(response => response.json())
            .then(data => {
                // do stuff
                if (document.querySelector('.schedule_delivery__container')) {
                    document.querySelector('.schedule_delivery__container').innerHTML = `<p class="schedule_delivery__element schedule_delivery_button" data-date-selected="false"><svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2840_41177)">
        <path d="M17.6508 0.00146485C17.8461 0.00145671 18.0395 0.0411001 18.22 0.118131C18.4005 0.195162 18.5644 0.308073 18.7025 0.450415C18.8407 0.592758 18.9502 0.761744 19.025 0.947726C19.0997 1.13371 19.1382 1.33304 19.1382 1.53435V2.70838H21.7393C22.1337 2.70843 22.512 2.86994 22.7909 3.1574C23.0698 3.44487 23.2265 3.83474 23.2266 4.24127V21.4681C23.2265 21.8747 23.0698 22.2645 22.7909 22.552C22.512 22.8395 22.1337 23.001 21.7393 23.001H2.41091C2.01645 23.001 1.63815 22.8395 1.35922 22.552C1.08029 22.2646 0.923567 21.8747 0.923532 21.4681V4.24127C0.923569 3.83472 1.08029 3.44484 1.35922 3.15738C1.63815 2.86991 2.01645 2.70841 2.41091 2.70838H5.01199V1.53435C5.01198 1.33305 5.05045 1.13372 5.1252 0.947744C5.19994 0.761767 5.30949 0.592783 5.4476 0.450442C5.58571 0.3081 5.74967 0.195188 5.93012 0.118153C6.11057 0.0411171 6.30397 0.00146653 6.49929 0.00146485C6.69461 0.00145671 6.88803 0.0411001 7.06848 0.118131C7.24894 0.195162 7.41291 0.308073 7.55103 0.450415C7.68914 0.592758 7.7987 0.761744 7.87345 0.947726C7.9482 1.13371 7.98667 1.33304 7.98667 1.53435V2.70838H10.5877V1.53435C10.5877 1.33305 10.6262 1.13372 10.701 0.947744C10.7757 0.761767 10.8853 0.592783 11.0234 0.450442C11.1615 0.3081 11.3254 0.195188 11.5059 0.118153C11.6863 0.0411171 11.8797 0.00146653 12.075 0.00146485C12.2704 0.00145667 12.4638 0.0411 12.6442 0.118131C12.8247 0.195162 12.9887 0.308073 13.1268 0.450415C13.2649 0.592758 13.3745 0.761744 13.4492 0.947726C13.524 1.13371 13.5624 1.33304 13.5624 1.53435V2.70838H16.1635V1.53435C16.1635 1.33305 16.202 1.13372 16.2767 0.947744C16.3515 0.761767 16.461 0.592783 16.5991 0.450442C16.7372 0.3081 16.9012 0.195188 17.0816 0.118153C17.2621 0.0411171 17.4555 0.00146653 17.6508 0.00146485ZM20.252 8.74057H3.89821V19.9352H20.252V8.74057Z" fill="#231F20"/>
        <path d="M8.91725 10.1587C9.01587 10.1587 9.11044 10.1991 9.18017 10.271C9.2499 10.3428 9.28907 10.4403 9.28906 10.542V13.3293C9.28905 13.4309 9.24987 13.5284 9.18015 13.6003C9.11042 13.6721 9.01586 13.7125 8.91725 13.7125H5.57201C5.4734 13.7125 5.37884 13.6721 5.30911 13.6003C5.23939 13.5284 5.20021 13.4309 5.2002 13.3293V10.542C5.20019 10.4403 5.23936 10.3428 5.30909 10.271C5.37882 10.1991 5.47339 10.1587 5.57201 10.1587H8.91725ZM8.54537 10.9252H5.94381V12.946H8.54537V10.9252Z" fill="#231F20"/>
        <path d="M13.7492 10.1587C13.9546 10.1587 14.1211 10.3303 14.1211 10.542V13.3293C14.1211 13.541 13.9546 13.7125 13.7492 13.7125H10.404C10.1987 13.7125 10.0322 13.541 10.0322 13.3293V10.542C10.0322 10.3303 10.1987 10.1587 10.404 10.1587H13.7492Z" fill="#231F20"/>
        <path d="M18.5812 10.1064C18.7866 10.1064 18.9531 10.278 18.9531 10.4897V13.2771C18.9531 13.4887 18.7866 13.6603 18.5812 13.6603H15.2361C15.0307 13.6603 14.8642 13.4887 14.8642 13.2771V10.4897C14.8642 10.278 15.0307 10.1064 15.2361 10.1064H18.5812Z" fill="#231F20"/>
        <path d="M13.7492 14.8462C13.9546 14.8462 14.1211 15.0178 14.1211 15.2295V18.0168C14.1211 18.2285 13.9546 18.4 13.7492 18.4H10.404C10.1987 18.4 10.0322 18.2285 10.0322 18.0168V15.2295C10.0322 15.0178 10.1987 14.8462 10.404 14.8462H13.7492Z" fill="#231F20"/>
        <path d="M8.91718 14.8979C9.12257 14.8979 9.28907 15.0695 9.28906 15.2812V18.0686C9.28903 18.2802 9.12254 18.4518 8.91718 18.4518H5.57201C5.36665 18.4518 5.20016 18.2802 5.20013 18.0686V15.2812C5.20012 15.0695 5.36662 14.8979 5.57201 14.8979H8.91718Z" fill="#231F20"/>
        <path d="M18.5812 14.7944C18.7866 14.7944 18.9531 14.966 18.9531 15.1777V17.965C18.9531 18.1767 18.7866 18.3483 18.5812 18.3482H15.2361C15.0307 18.3483 14.8642 18.1767 14.8642 17.965V15.1777C14.8642 14.966 15.0307 14.7944 15.2361 14.7944H18.5812Z" fill="#231F20"/>
    </g>
    <defs>
        <clipPath id="clip0_2840_41177">
            <rect width="22.303" height="23" fill="white" transform="matrix(-1 0 0 1 23.2266 0)"/>
        </clipPath>
    </defs>
</svg>
<span>${deliveryDate.deliveryDateTrigger}</span></p>`
                  if (addToCartButton?.length > 0) {
                    addToCartButton.querySelector('span').textContent = "Add to Cart";
                  }
                }
                modal.removeAttribute("active");
            })
            .catch(error => console.error('Error:', error));
        // Close the modal

    }

    function resetCalendarState() {
        // Clear any selected date
        selectedDate = null;
        selectedDateText.textContent = "";

        // Disable the "Schedule Order" button
        scheduleDeliveryModalAdd.setAttribute("disabled", true);

        // Remove the 'selected' class from all calendar buttons
        document.querySelectorAll("#calendar button").forEach((btn) =>
            btn.classList.remove("selected")
        );
    }

    // Clear the selected date and close the modal
    function clearAndCloseModal() {
        clearSelection();
        resetCalendarState();
        modal.removeAttribute("active");
    }
    function closeModal() {
        resetCalendarState();
        modal.removeAttribute("active");
    }

    // Handle clicking the "Schedule Order" button
    scheduleDeliveryModalAdd.addEventListener("click", function (e) {
        e.preventDefault();
        if (selectedDateString) {
            // Trigger Add to Cart button
            cartAttributes["Delivery Date"] = selectedDateString;

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: cartAttributes
                })
            })
                .then(response => response.json())
                .then(data => {
                    // do stuff
                    if (document.querySelector('.schedule_delivery__container')) {
                        document.querySelector('.schedule_delivery__container').innerHTML = `<p class="schedule_delivery__element schedule_delivery_button" data-date-selected="true"><svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2840_41177)">
        <path d="M17.6508 0.00146485C17.8461 0.00145671 18.0395 0.0411001 18.22 0.118131C18.4005 0.195162 18.5644 0.308073 18.7025 0.450415C18.8407 0.592758 18.9502 0.761744 19.025 0.947726C19.0997 1.13371 19.1382 1.33304 19.1382 1.53435V2.70838H21.7393C22.1337 2.70843 22.512 2.86994 22.7909 3.1574C23.0698 3.44487 23.2265 3.83474 23.2266 4.24127V21.4681C23.2265 21.8747 23.0698 22.2645 22.7909 22.552C22.512 22.8395 22.1337 23.001 21.7393 23.001H2.41091C2.01645 23.001 1.63815 22.8395 1.35922 22.552C1.08029 22.2646 0.923567 21.8747 0.923532 21.4681V4.24127C0.923569 3.83472 1.08029 3.44484 1.35922 3.15738C1.63815 2.86991 2.01645 2.70841 2.41091 2.70838H5.01199V1.53435C5.01198 1.33305 5.05045 1.13372 5.1252 0.947744C5.19994 0.761767 5.30949 0.592783 5.4476 0.450442C5.58571 0.3081 5.74967 0.195188 5.93012 0.118153C6.11057 0.0411171 6.30397 0.00146653 6.49929 0.00146485C6.69461 0.00145671 6.88803 0.0411001 7.06848 0.118131C7.24894 0.195162 7.41291 0.308073 7.55103 0.450415C7.68914 0.592758 7.7987 0.761744 7.87345 0.947726C7.9482 1.13371 7.98667 1.33304 7.98667 1.53435V2.70838H10.5877V1.53435C10.5877 1.33305 10.6262 1.13372 10.701 0.947744C10.7757 0.761767 10.8853 0.592783 11.0234 0.450442C11.1615 0.3081 11.3254 0.195188 11.5059 0.118153C11.6863 0.0411171 11.8797 0.00146653 12.075 0.00146485C12.2704 0.00145667 12.4638 0.0411 12.6442 0.118131C12.8247 0.195162 12.9887 0.308073 13.1268 0.450415C13.2649 0.592758 13.3745 0.761744 13.4492 0.947726C13.524 1.13371 13.5624 1.33304 13.5624 1.53435V2.70838H16.1635V1.53435C16.1635 1.33305 16.202 1.13372 16.2767 0.947744C16.3515 0.761767 16.461 0.592783 16.5991 0.450442C16.7372 0.3081 16.9012 0.195188 17.0816 0.118153C17.2621 0.0411171 17.4555 0.00146653 17.6508 0.00146485ZM20.252 8.74057H3.89821V19.9352H20.252V8.74057Z" fill="#231F20"/>
        <path d="M8.91725 10.1587C9.01587 10.1587 9.11044 10.1991 9.18017 10.271C9.2499 10.3428 9.28907 10.4403 9.28906 10.542V13.3293C9.28905 13.4309 9.24987 13.5284 9.18015 13.6003C9.11042 13.6721 9.01586 13.7125 8.91725 13.7125H5.57201C5.4734 13.7125 5.37884 13.6721 5.30911 13.6003C5.23939 13.5284 5.20021 13.4309 5.2002 13.3293V10.542C5.20019 10.4403 5.23936 10.3428 5.30909 10.271C5.37882 10.1991 5.47339 10.1587 5.57201 10.1587H8.91725ZM8.54537 10.9252H5.94381V12.946H8.54537V10.9252Z" fill="#231F20"/>
        <path d="M13.7492 10.1587C13.9546 10.1587 14.1211 10.3303 14.1211 10.542V13.3293C14.1211 13.541 13.9546 13.7125 13.7492 13.7125H10.404C10.1987 13.7125 10.0322 13.541 10.0322 13.3293V10.542C10.0322 10.3303 10.1987 10.1587 10.404 10.1587H13.7492Z" fill="#231F20"/>
        <path d="M18.5812 10.1064C18.7866 10.1064 18.9531 10.278 18.9531 10.4897V13.2771C18.9531 13.4887 18.7866 13.6603 18.5812 13.6603H15.2361C15.0307 13.6603 14.8642 13.4887 14.8642 13.2771V10.4897C14.8642 10.278 15.0307 10.1064 15.2361 10.1064H18.5812Z" fill="#231F20"/>
        <path d="M13.7492 14.8462C13.9546 14.8462 14.1211 15.0178 14.1211 15.2295V18.0168C14.1211 18.2285 13.9546 18.4 13.7492 18.4H10.404C10.1987 18.4 10.0322 18.2285 10.0322 18.0168V15.2295C10.0322 15.0178 10.1987 14.8462 10.404 14.8462H13.7492Z" fill="#231F20"/>
        <path d="M8.91718 14.8979C9.12257 14.8979 9.28907 15.0695 9.28906 15.2812V18.0686C9.28903 18.2802 9.12254 18.4518 8.91718 18.4518H5.57201C5.36665 18.4518 5.20016 18.2802 5.20013 18.0686V15.2812C5.20012 15.0695 5.36662 14.8979 5.57201 14.8979H8.91718Z" fill="#231F20"/>
        <path d="M18.5812 14.7944C18.7866 14.7944 18.9531 14.966 18.9531 15.1777V17.965C18.9531 18.1767 18.7866 18.3483 18.5812 18.3482H15.2361C15.0307 18.3483 14.8642 18.1767 14.8642 17.965V15.1777C14.8642 14.966 15.0307 14.7944 15.2361 14.7944H18.5812Z" fill="#231F20"/>
    </g>
    <defs>
        <clipPath id="clip0_2840_41177">
            <rect width="22.303" height="23" fill="white" transform="matrix(-1 0 0 1 23.2266 0)"/>
        </clipPath>
    </defs>
</svg>
<b>${cartAttributes["Delivery Date"]}</b>
<span>${deliveryDate.deliveryDateHyperlinkTriggerActive}</span></p>`
                      if (addToCartButton?.length > 0) {
                        addToCartButton.querySelector('span').textContent = "Add to Delivery";
                      }
                    }

                    modal.removeAttribute("active");
                    resetCalendarState();
                })
                .catch(error => console.error('Error:', error));
            // Close the modal

        }
    });

    // Handle clicking the "Clear" button
    clearButton.addEventListener("click", function () {
        clearSelection();
    });

    // Handle clicking the "x" button
    closeButton.addEventListener("click", function () {
        closeModal();
    });

    // Handle month navigation buttons
    prevMonthButton.addEventListener("click", function () {
        changeMonth(-1);
    });

    nextMonthButton.addEventListener("click", function () {
        changeMonth(1);
    });

    // Handle dropdown change
    monthDropdown.addEventListener("change", function () {
        const selectedOption = monthDropdown.value.split("-");
        currentYear = parseInt(selectedOption[0], 10);
        currentMonth = parseInt(selectedOption[1], 10);
        generateCalendar(currentYear, currentMonth);
    });

    // Change the month and regenerate the calendar
    function changeMonth(direction) {
        const tempDate = new Date(currentYear, currentMonth + direction);
        const startDate = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the current month
        const endDate = new Date(today.getFullYear(), today.getMonth() + 12, 0); // Last day of the 12th month from now

        // Ensure navigation stays within the valid date range
        if (tempDate >= startDate && tempDate <= endDate) {
            currentMonth += direction;

            if (currentMonth < 0) {
                currentMonth = 11;
                currentYear--;
            } else if (currentMonth > 11) {
                currentMonth = 0;
                currentYear++;
            }

            // Update the dropdown and regenerate the calendar
            updateMonthDropdown(currentYear, currentMonth);
            generateCalendar(currentYear, currentMonth);
        }
    }
});